export default __webpack_public_path__ + "static/33F324_6_0-97b889c7e552367c93d642cb61b28dde.eot";